.root {
  aspect-ratio: 1;
}
